module.exports = __webpack_public_path__ + "img/Butterfly_00226.a8677666.png";